<div>
    <div class="heading">
        <h3>{{data.purchaseItem ? 'Update' : 'Add'}} Purchase Item</h3>
        <span (click)="onNoClick()"><mat-icon>close</mat-icon></span>
     </div>
     <div class="body-user">
        <fxLayout fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px"
        style="margin-bottom: 20px;align-items: baseline;">
        <form [formGroup]="purchaseItem" style="width: 100%;">
            <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
                <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>Order Number</mat-label>
                    <input matInput placeholder="Order Number" formControlName="orderNumber">
                </mat-form-field>
    
                <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>Order Date</mat-label>
                    <input matInput [matDatepicker]="picker" formControlName="orderDate" (click)="picker.open()" [min]="minDate" readonly>
                    <!-- <mat-hint>MM/DD/YYYY</mat-hint> -->
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                    <mat-error *ngIf="purchaseItem.controls['orderDate'].touched && purchaseItem.controls['orderDate'].hasError('required')">
                        This is required
                    </mat-error>
                </mat-form-field>
                
               
            </div>
            <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
                <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>Cover Item</mat-label>
                    <input
                      matInput
                      placeholder="Select item"
                      aria-label="itemName"
                      [matAutocomplete]="auto"
                      formControlName="itemName"
                      (ngModelChange)="onchangeCoverItem($event)" 
                    />
                    <mat-autocomplete #auto="matAutocomplete">
                      <mat-option
                        *ngFor="let item of searchCoverItemList | async"
                        [value]="item?.title"
                        [disabled]="item?.id === 0"
                      >
                        <span>{{item?.title}}</span>
                      </mat-option>
                    </mat-autocomplete>
                    <mat-error *ngIf="purchaseItem.controls['itemName'].touched && purchaseItem.controls['itemName'].hasError('required')">
                        This is required
                    </mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>Item Parts</mat-label>
                    <input matInput placeholder="Item Parts" formControlName="itemParts">
                </mat-form-field>
            </div>
            <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
                
                <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>Color</mat-label>
                    <input matInput placeholder="Color" formControlName="color">
                </mat-form-field>
                <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>Supplier</mat-label>
                    <input matInput placeholder="Supplier" formControlName="supplier">
                </mat-form-field>
            </div>
           
                <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
                    <mat-form-field appearance="outline" fxFlex="auto">
                        <mat-label>Tracking</mat-label>
                        <input matInput placeholder="Tracking" formControlName="tracking">
                    </mat-form-field>
                    <mat-form-field appearance="outline" fxFlex="auto">
                        <mat-label>Delivery Date</mat-label>
                        <input matInput [matDatepicker]="picker2" formControlName="deliveryDate" (click)="picker2.open()" [min]="minDate" readonly>
                        <!-- <mat-hint>MM/DD/YYYY</mat-hint> -->
                        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                        <mat-datepicker #picker2></mat-datepicker>
                        <mat-error *ngIf="purchaseItem.controls['deliveryDate'].touched && purchaseItem.controls['deliveryDate'].hasError('required')">
                            This is required
                        </mat-error>
                    </mat-form-field>
                </div>
                <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
                    <mat-form-field appearance="outline" fxFlex="auto">
                        <mat-label>Total Amount</mat-label>
                        <input matInput placeholder="Total Amount" formControlName="totalAmount"  mask="separator.2" thousandSeparator=","  [prefix]="purchaseItem.controls['totalAmount'].value ? '$' : ''">
                        <mat-error *ngIf="purchaseItem.controls['totalAmount'].touched && purchaseItem.controls['totalAmount'].hasError('required')">
                            This is required
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline" fxFlex="auto">
                        <mat-label>Status</mat-label>
                        <mat-select formControlName="status">
                            <mat-option *ngFor="let item of statusList" [value]="item">{{item}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="purchaseItem.controls['status'].touched && purchaseItem.controls['status'].hasError('required')">
                        This is required
                    </mat-error>
                    </mat-form-field>
                </div>
            <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
                
                <mat-form-field appearance="outline" fxFlex="auto">
                    <mat-label>Note</mat-label>
                    <textarea matInput placeholder="Note" formControlName="specialNotes"></textarea>
                    <mat-error *ngIf="purchaseItem.controls['specialNotes'].touched && purchaseItem.controls['specialNotes'].hasError('required')">
                        This is required
                    </mat-error>
                </mat-form-field>
            </div>
            
        </form>
      </fxLayout>
      <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
        <button mat-button class="sub-button" (click)="addEditPurchaseItem()"><span>{{data.purchaseItem ? 'Update' : 'Add'}}</span></button>
        <button mat-button mat-dialog-close class="can-button" (click)="onNoClick()"><span>Close</span></button>
    </div>
     </div>
     
</div>
